<template>
  <div>
    <custom-callout
      apply-border-top
      :controlled="true"
      :has-border="false"
      has-gradient
      has-toggle
      :opened="activeIndex === index"
      @click:open="onUpdateActiveIndex"
    >
      <section class="student-detail row w-100 py-3">
        <div class="col-md-4 ">
          <CustomInputDisplay
            label="Nombre del Estudiante:"
            label-class="text-gray font-weight-light"
            :value="item.studentName + '-' + item.studentSieId"
            class="span-student ml-0"
          />
        </div>
        <div class="col-md-4">
          <CustomInputDisplay
            label="Escuela:"
            label-class="text-gray font-weight-light"
            :value="item.schoolCode + ' - ' + item.schoolName"
            class="font-weight-bold pl-3"
          />
        </div>
        <div class="col-md-4 pr-0">
          <action-button
            type="submit"
            text="Ver Detalles"
            i="fas fa-file-search"
            variant="outline-success"
            class="see-details-btn"
            @click="onUpdateActiveIndex"
          />
        </div>
      </section>
      <section>
        <weekly-progress-legend
          :progress="item.progress"
        ></weekly-progress-legend>
      </section>
      <template #edition>
        <div class="bg-gray p-2">
          <AdditionalProgressInformation
            :academicYearId="academicYear"
            :sie="item.studentSieId"
            :only-psc="onlyPsc"
            @edit="handlerGoToEdit"
            @view="handlerGoToView"
            @download="handlerPrintReport"
            @saved="onSaveAmend()"
            @onSaveDiscussion="onSaveAmend()"
            @download-discussion="handlerDownloadDiscussion"
          />
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';
import WeeklyProgressLegend from './WeeklyProgressLegend.vue';
import AdditionalProgressInformation from './AdditionalProgressInformation.vue';
const EDUCATIONAL_SERVICES_PROGRAM_PAGE = 'educational-services-program';
import DocumentsService from '@/services/report';
import docService from '@/services/documents';

export default {
  components: {
    CustomCallout,
    CustomInputDisplay,
    ActionButton,
    WeeklyProgressLegend,
    AdditionalProgressInformation,
  },
  props: {
    item: {
      type: Object,
    },
    search: {
      type: Function,
      default: () => undefined,
    },
    academicYear: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    activeIndex: {
      type: Number,
      default: null,
    },
    onlyPsc: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handlerGoToEdit(item) {
      const params = {
        studentSie: this.item.studentSieId,
        academicYear: this.academicYear,
        week: item.week,
        id: item.academicProgressId,
        onlyPsc: this.onlyPsc,
      };
      this.$router.push({ name: EDUCATIONAL_SERVICES_PROGRAM_PAGE, params });
    },
    handlerGoToView({ week, academicProgressId: id }) {
      const params = {
        studentSie: this.item.studentSieId,
        academicYear: this.academicYear,
        week,
        onlyPsc: this.onlyPsc,
        id,
      };
      this.$router.push({ name: EDUCATIONAL_SERVICES_PROGRAM_PAGE, params });
    },
    async handlerPrintReport(academicProgressId) {
      await DocumentsService.downloadStudentAcademicProgress(
        academicProgressId
      );
    },
    onSaveAmend() {
      this.$emit('saved');
    },
    async handlerDownloadDiscussion(documentId) {
      await docService.downloadDocumentByAttachmentIdOrDocumentId(documentId);
    },
    onUpdateActiveIndex() {
      const newIndex = this.activeIndex === this.index ? null : this.index;
      this.$emit('update-active-index', newIndex);
    },
  },
};
</script>

<style scope>
.student-detail {
  border-bottom: 1px solid #dee2e6;
}

.span-student .position-relative label {
  font-weight: bold !important;
}
.see-details-btn {
  position: relative;
  float: right;
  top: 15%;
}
</style>
